const useSessionTypes = () => {
  const SET_SESSION_BRAND = "SET_SESSION_BRAND";
  const SET_SESSION_PROCESS = "SET_SESSION_PROCESS";

  return { SET_SESSION_BRAND, SET_SESSION_PROCESS };
};

export default useSessionTypes;
